import React, { useState, useEffect } from 'react';
import { FormGroup, Input } from 'src/components/ui';
import { useDebouncedEffect } from '../../hooks/useDebounceEffect';
import useTestId from '../../hooks/useTestId';
import { useAutofillSafeName } from '../../hooks/useAutofillSafeName';
import classnames from '../../util/classnames';

export default function TextArea({ id, uiSchema, value, required, disabled, readonly, autofocus, onChange: onChangeForm }) {
  const [current, setCurrent] = useState(value);
  const testIdProps = useTestId(id);
  const autofillSafeName = useAutofillSafeName();

  useDebouncedEffect(
    () => {
      if (current !== value) {
        onChangeForm(current);
      }
    },
    [current],
    450
  );

  const rows = (uiSchema['ui:options'] || {}).rows || 3;
  const staticText = uiSchema['ui:staticText'];
  const classNames = uiSchema['ui:classNames'];
  useEffect(() => setCurrent(value), [value]);
  return (
    <FormGroup className={classnames({ 'input-wrapper': !staticText })}>
      {staticText ? (
        <div className={classNames} style={{ whiteSpace: 'pre-wrap' }}>
          {current || ''}
        </div>
      ) : (
        <Input
          disabled={disabled}
          type="textarea"
          name={autofillSafeName}
          autoComplete="off"
          className={classnames('custom', classNames)}
          placeholder={`${uiSchema['ui:placeHolder'] || undefined || ''}`}
          value={current || ''}
          required={required}
          onChange={e => setCurrent(e.target.value)}
          readOnly={readonly}
          autoFocus={autofocus}
          id={id}
          {...testIdProps}
          rows={rows}
          maxLength={uiSchema['ui:maxLength'] || undefined}
        />
      )}
    </FormGroup>
  );
}
